// Ordre du parcours d'accueil (05, « Parcours »), sans React : testé seul.
import type { Moi } from '../lib/api';

export type Etape = 'installer' | 'consentir' | 'activer' | 'regler' | 'confirmation' | 'jour';

/** L'étape où en est ce membre sur cet appareil (fonction pure, testée). */
export function etapeDuParcours(
  moi: Moi,
  appareil: { iosNonInstallee: boolean; pushActif: boolean; testRecu: boolean },
): Etape {
  if (appareil.iosNonInstallee) return 'installer';
  if (moi.consentement.version !== moi.consentement.versionCourante) return 'consentir';
  if (!appareil.pushActif || moi.abonnements === 0 || !appareil.testRecu) return 'activer';
  if (moi.role === 'elle' && !moi.reglagesComplets) return 'regler';
  // Le proche choisit une fois les messages qu'il reçoit (#27, option B).
  if (moi.role === 'proche' && moi.confirmation === null) return 'confirmation';
  return 'jour';
}
